import { render, staticRenderFns } from "./FormIncidentType.vue?vue&type=template&id=60e1c1f2&"
import script from "./FormIncidentType.vue?vue&type=script&lang=js&"
export * from "./FormIncidentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports